import React from "react";
import { useDispatch, useSelector } from "react-redux";

import ManageBookingItem from "../../../components/OrderManagement/ManageBookingItem";
import {
  setSections,
  setPageNext,
  setPagePrev,
} from "../../../redux/booking/booking-slice";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowAltCircleLeft,
  faArrowAltCircleRight,
} from "@fortawesome/fontawesome-free-solid";
import { setProfileBoxAction } from "../../../redux/auth/auth-slice";
import { Link } from "react-router-dom";

import NotFoundIcon from "../../../assets/svg/not-found-icon";

export default function OrdersManagementPage() {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);
  const { token } = useSelector((state) => state.auth);
  const {
    bookings,
    pageCount,
    totalBookingCount,
    bookingsLoading,
    upcomingBooking,
    upcomingBookingLength,
    jobsForTodayLength,
    jobsForToday,
    jobsForTomorrowLength,
    jobsForTomorrow,
    sections,
    filteredBookings,
    filteredBookingsNumber,
    filteredNotFound,
    isSearch,
    notFound,
  } = useSelector((state) => state.booking);

  React.useEffect(() => {
    if (token) {
      dispatch({
        type: "BOOKING_ASSIGNED",
        payload: {
          token: token,
          pageNumber: pageCount,
        },
      });
    }
  }, [pageCount, token]);

  React.useEffect(() => {
    dispatch(setProfileBoxAction({ profileBoxAction: false }));
  }, []);

  return (
    <div
      className="grid h-full grid-cols-1 gap-x-10 gap-y-5 overflow-auto bg-black p-4 scrollbar"
      onClick={() => {
        dispatch(setProfileBoxAction({ profileBoxAction: false }));
      }}
    >
      {bookingsLoading && (
        <div class="flex h-full items-center justify-center bg-black">
          <div class="loader">
            <div class="inner one"></div>
            <div class="inner two"></div>
            <div class="inner three"></div>
          </div>
        </div>
      )}

      {!bookingsLoading && (
        <>
          {isSearch && notFound && (
            <div className="mx-auto mt-[4.875rem] flex flex-col items-center">
              <NotFoundIcon />
              <div className="text-center text-5xl font-bold leading-[1.5]">
                Search Result Not found
              </div>
            </div>
          )}

          {isSearch &&
            !notFound &&
            filteredBookings?.map((booking) => (
              <ManageBookingItem
                bookingId={booking?.bookingId}
                Bookingtype={booking?.bookingType}
                pickupLocation={booking?.source?.placename}
                dropofLocation={booking?.destination?.placename}
                travelDate={booking?.travelDate}
                travelTime={booking?.travelTime}
                amount={booking?.purchasePrice}
                currency={booking?.purchaseCurrency}
                vehicletype={booking?.vehicleDetails?.categoryType}
                bookingStatus={booking?.bookingStatus}
                duration={
                  booking?.durationForAffiliate
                    ? booking?.durationForAffiliate + " hours"
                    : booking?.duration
                }
                spreq={booking?.passengerDetails?.specialRequest}
                travelDistance={booking?.travelDistance}
                driverName={
                  booking?.driverDetails
                    ? booking?.driverDetails?.name
                    : "Driver not assigned!"
                }
                driverContact={
                  booking?.driverDetails
                    ? booking?.driverDetails?.contactNumber
                    : "No contact found!"
                }
                driverCountryCode={
                  booking?.driverDetails
                    ? booking?.driverDetails?.countryCode
                    : ""
                }
                affiliateNote={booking?.affiliateNote}
              />
            ))}

          {sections?.allBooking &&
            !isSearch &&
            bookings.map((booking) => (
              <div key={booking?._id}>
                <ManageBookingItem
                  bookingId={booking?.bookingId}
                  Bookingtype={booking?.bookingType}
                  pickupLocation={booking?.source?.placename}
                  dropofLocation={booking?.destination?.placename}
                  travelDate={booking?.travelDate}
                  travelTime={booking?.travelTime}
                  amount={booking?.purchasePrice}
                  currency={booking?.purchaseCurrency}
                  vehicletype={booking?.vehicleDetails?.categoryType}
                  bookingStatus={booking?.bookingStatus}
                  duration={
                    booking?.durationForAffiliate
                      ? booking?.durationForAffiliate + " hours"
                      : booking?.duration
                  }
                  spreq={booking?.passengerDetails?.specialRequest}
                  travelDistance={booking?.travelDistance}
                  driverName={
                    booking?.driverDetails
                      ? booking?.driverDetails?.name
                      : "Driver not assigned!"
                  }
                  driverContact={
                    booking?.driverDetails
                      ? booking?.driverDetails?.contactNumber
                      : "No contact found!"
                  }
                  driverCountryCode={
                    booking?.driverDetails
                      ? booking?.driverDetails?.countryCode
                      : ""
                  }
                  affiliateNote={booking?.affiliateNote}
                />
              </div>
            ))}

          {sections?.upcomingBooking &&
            !isSearch &&
            upcomingBooking.map((booking) => (
              <ManageBookingItem
                key={booking?._id}
                bookingId={booking?.bookingId}
                Bookingtype={booking?.bookingType}
                pickupLocation={booking?.source?.placename}
                dropofLocation={booking?.destination?.placename}
                travelDate={booking?.travelDate}
                travelTime={booking?.travelTime}
                amount={booking?.purchasePrice}
                currency={booking?.purchaseCurrency}
                vehicletype={booking?.vehicleDetails?.categoryType}
                bookingStatus={booking?.bookingStatus}
                duration={
                  booking?.durationForAffiliate
                    ? booking?.durationForAffiliate + " hours"
                    : booking?.duration
                }
                spreq={booking?.passengerDetails?.specialRequest}
                travelDistance={booking?.travelDistance}
              />
            ))}

          {sections?.jobsForToday &&
            !isSearch &&
            jobsForToday.map((booking) => (
              <>
                <div key={booking?._id}>
                  <ManageBookingItem
                    bookingId={booking?.bookingId}
                    Bookingtype={booking?.bookingType}
                    pickupLocation={booking?.source?.placename}
                    dropofLocation={booking?.destination?.placename}
                    travelDate={booking?.travelDate}
                    travelTime={booking?.travelTime}
                    amount={booking?.purchasePrice}
                    currency={booking?.purchaseCurrency}
                    vehicletype={booking?.vehicleDetails?.categoryType}
                    bookingStatus={booking?.bookingStatus}
                    duration={
                      booking?.durationForAffiliate
                        ? booking?.durationForAffiliate + " hours"
                        : booking?.duration
                    }
                    spreq={booking?.passengerDetails?.specialRequest}
                    travelDistance={booking?.travelDistance}
                  />
                </div>
              </>
            ))}

          {sections?.jobsForTomorrow &&
            !isSearch &&
            jobsForTomorrow.map((booking) => (
              <>
                <div key={booking?._id}>
                  <ManageBookingItem
                    bookingId={booking?.bookingId}
                    Bookingtype={booking?.bookingType}
                    pickupLocation={booking?.source?.placename}
                    dropofLocation={booking?.destination?.placename}
                    travelDate={booking?.travelDate}
                    travelTime={booking?.travelTime}
                    amount={booking?.purchasePrice}
                    currency={booking?.purchaseCurrency}
                    vehicletype={booking?.vehicleDetails?.categoryType}
                    bookingStatus={booking?.bookingStatus}
                    duration={
                      booking?.durationForAffiliate
                        ? booking?.durationForAffiliate + " hours"
                        : booking?.duration
                    }
                    spreq={booking?.passengerDetails?.specialRequest}
                    travelDistance={booking?.travelDistance}
                  />
                </div>
              </>
            ))}
        </>
      )}
    </div>
  );
}
